module.exports = __webpack_public_path__ + "static/media/qr_course_id_531.cc0362fc.png";